import { html } from 'lit';
import { Filter } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-filter')
export class PdsIconFilter extends PdsIcon {
  @state()
  icon = Filter;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
